module.exports = __webpack_public_path__ + "img/benefits-23.9dad44ce.svg";